export function module_dogrun() {
  $(function() {
    // 初期化時に一度だけイベントハンドラを設定する
    setupDogrunQAHandlers();
    
    var timer = false;
    var winWidth = $(window).width();
    var winHeight = $(window).height();

    $(window).on("resize", function() {
      // リサイズ中の連続実行を防止
      if (timer !== false) {
        clearTimeout(timer);
      }

      // 指定時間後に処理を実行
      timer = setTimeout(function() {
        // リサイズ後のウインドウサイズを取得
        const winWidth_resized = $(window).width();
        const winHeight_resized = $(window).height();

        // サイズが変わった場合のみ処理を実行
        if (winWidth !== winWidth_resized || winHeight !== winHeight_resized) {
          // イベントハンドラをいったん解除してから再設定
          removeDogrunQAHandlers();
          setupDogrunQAHandlers();
          
          // 次回比較用にサイズを更新
          winWidth = winWidth_resized;
          winHeight = winHeight_resized;
        }
      }, 200);
    });

    // クリックイベントハンドラを設定する関数
    function setupDogrunQAHandlers() {
      $(".dogrunQaList__term").on("click", function() {
        $(this).toggleClass("open close");
        $(this).next(".dogrunQaList__desc").toggleClass("active");
      });
    }
    
    // クリックイベントハンドラを解除する関数
    function removeDogrunQAHandlers() {
      $(".dogrunQaList__term").off("click");
    }
  });
}